import Paper from "@material-ui/core/es/Paper/Paper";
import React from "react";

import ActionBar from "../components/ActionBar";
import Loader from "../components/Loader";
import VLButton from "../components/VLButton";
import * as API from "../util/api";
import * as Util from "../util/util";
import VLComponent from "./VLComponent";

export default class PairingScreen extends VLComponent {

    constructor() {
        super();
        this.state = {loaded: true, error: ""};
    }

    componentDidMount() {

    };

    render() {
        return (
            <div>
                <ActionBar title="Vision Link Web Portal" hideAll={true}/>
                {this.renderTextAlert()}
                <div id="content" style={{
                    display: this.state.loaded ? "flex" : "none",
                    width: "100%",
                    justifyContent: "center",
                    padding: 16,
                    alignItems: "center",
                    height: "calc(100vh - 70px)"
                }}>
                    <Paper style={{width: "15cm", padding: 32, borderRadius: 16, overflowY: "auto", maxHeight: "100%"}}>
                        <div>
                            <img src="https://api.vision-link.co.uk/app_logo/VL.png"
                                 style={{width: "calc(100% - 60px)", margin: 30}}/>
                        </div>

                        {this.warnIe()}
                        <p style={{textAlign: "center"}}>To begin monitoring your local community systems, please enter
                            your 6 digit unique pairing code below.</p>
                        <p style={{textAlign: "center"}}>Don't have a code? Please contact Vision Link at <a
                            href="mailto:support@vision-link.co.uk">support@vision-link.co.uk</a></p>
                        <br/>
                        {this.renderForm()}
                        <br/><br/>
                    </Paper>
                </div>
                <Loader loaded={this.state.loaded}/>
            </div>
        );
    }

    warnIe = () => {
        if (Util.isIE()) {
            return <p style={{textAlign: "center", color: "red"}}>Warning: You seem to be using Internet Explorer. We
                recommend you use Google Chrome for the best experience.</p>;
        }
    };

    renderForm = () => {
        return (
            <div>
                <p className="nomargin"><b>Pairing Code</b></p>
                <input name="pairing_code" className="vl-input wide top8" placeholder="Enter your pairing code here"
                       value={this.state.pairing_code} maxlength="6"
                       onChange={this.handleNumberInputChange}/>
                <br/><br/>

                <VLButton title="Pair" className="wide top8" onClick={this.login}/>
            </div>
        );
    };

    login = () => {
        let pairing_code = this.state.pairing_code;
        localStorage.setItem("pairing_code", pairing_code);
        API.POST("account/communityPair", {}, result => {
            if (result.success) {
                let app_name = result.result.app_name;
                let pairing_code = result.result.pairing_code;

                localStorage.setItem("app_name", app_name);

                this.showTextAlert("Disclaimer", "Data provided is to give an indicative level of the local river for information only. Please do not use the data for any other purpose.", "Okay", "", this.redirect);
            } else {
                this.setState({error: result.error});
            }
        });
    };

    redirect = () => {
        let redirect = Util.GET("redirect", encodeURIComponent("/"));
        redirect = decodeURIComponent(redirect);
        window.open(redirect, "_self", "", true);
    };

}